import { Spin } from '@mis/sushi-tailwind-react';
import { useMatch } from '@tanstack/react-location';
import { AxiosError } from 'axios';
import { useEffect } from 'react';

const ErrorRouteFetch = (): React.ReactElement => {
  const match = useMatch();
  useEffect(() => {
    const { error } = match;
    if (error && (error as AxiosError).response) {
      const code = (error as AxiosError).response?.status;
      if (code === 401) {
        window.location.href = '/digitalipo';
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [match]);

  return (
    <div className="flex h-screen w-full flex-col items-center justify-center">
      <Spin />
    </div>
  );
};

export default ErrorRouteFetch;
